import { render } from "./PaginationBar.vue?vue&type=template&id=774e31d2&ts=true"
import script from "./PaginationBar.vue?vue&type=script&lang=ts"
export * from "./PaginationBar.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__